import React, { useEffect, useState, useCallback } from 'react';
import update from 'immutability-helper';
import { Card } from './Card';

export default function Container(props) {
  const {
    itemData,
    menuItemIndex,
    user,
    menuHighlight,
    connectors,
    activeCreateMenuConnection,
    updateMenuItem,
    removeMenuItem,
    isCreating,
    doUpdateItemWithDebounce,
    handleMenuOptionHighLight,
    currentPath,
  } = props;

  const [draggingCard, setDraggingCard] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const [cards, setCards] = useState(itemData?.menuItems || []);

  useEffect(() => {
    cards.forEach((card) => {
      const ref = document.getElementById(card._id);
      if (ref) {
        ref.blur();
      }
    });
    if (!isDragging) {
      setDraggingCard('');
    }
    handleMenuOptionHighLight('');
  }, [isDragging]);

  useEffect(() => {
    setCards(itemData?.menuItems);
  }, [itemData?.menuItems]);

  const handleUpdateList = (param) => {
    setCards(param);
    doUpdateItemWithDebounce({ menuItems: param });
  };

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const dragCard = cards[dragIndex];
      handleUpdateList(
        update(cards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        })
      );
    },
    [cards]
  );

  const renderCard = (menuItem, index) => {
    return (
      <Card
        key={String(index)}
        id={menuItem._id}
        index={index}
        menuItemIndex={menuItemIndex}
        menuHighlight={menuHighlight}
        user={user}
        menuItem={menuItem}
        activeCreateMenuConnection={activeCreateMenuConnection}
        updateMenuItem={updateMenuItem}
        removeMenuItem={removeMenuItem}
        connectors={connectors}
        setIsDragging={setIsDragging}
        generalIsDragging={isDragging}
        moveCard={moveCard}
        isCreating={isCreating}
        draggingCard={draggingCard}
        setDraggingCard={setDraggingCard}
        handleMenuOptionHighLight={handleMenuOptionHighLight}
        currentPath={currentPath}
      />
    );
  };

  return (
    <div className="div-block-menu-item">
      {cards.map((menuItem, i) => renderCard(menuItem, i))}
    </div>
  );
}
